import React, { ChangeEvent } from 'react'

import { FlexContainer, YSpacing } from '@components/common'
import { Checkbox, AutocompleteInput } from '@components/common/form'
import { CobrandingSettings } from '@types'

const cobrandingOptions = [
  {
    id: '',
    label: 'Not Selected',
  },
  {
    id: 'roku',
    label: 'Roku',
  },
]

const getCobrandingLabel = (id: string) => {
  return cobrandingOptions.find((o) => o.id === id)?.label || ''
}

interface CobrandingSettingsSectionProps {
  settings: CobrandingSettings | null
  onChangeCobrandingSettings: (
    field: keyof CobrandingSettings,
  ) => (value: string | boolean) => void
}

const CobrandingSettingsSection: React.FC<CobrandingSettingsSectionProps> = ({
  settings,
  onChangeCobrandingSettings,
}) => {
  return (
    <FlexContainer flexDirection="column" width="100%">
      <Checkbox
        label="Use cobranding elements?"
        checked={settings?.active}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChangeCobrandingSettings('active')(e.target.checked)
        }
      />
      {settings?.active && (
        <>
          <YSpacing height="10px" />
          <FlexContainer flexDirection="column" width="100%">
            <AutocompleteInput
              label="GO Web Cobranded Nav Bar ID"
              displayAttribute="label"
              value={getCobrandingLabel(settings?.navBarId || '')}
              loaderFunction={() => {
                return cobrandingOptions
              }}
              onSelect={(opt: { id: string; label: string }) =>
                onChangeCobrandingSettings('navBarId')(opt.id)
              }
            />
          </FlexContainer>
        </>
      )}
      <YSpacing height="10px" />
    </FlexContainer>
  )
}

export default CobrandingSettingsSection
